import Channel from './Channel'
export default Channel
